import React from 'react';
import '../../../css/style.scss'
import Button from "@material-ui/core/Button";
import { themeButtons } from "../../../css/themeButtons";
import IconButton from "@material-ui/core/IconButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import CloseIcon from "@material-ui/icons/Close";
import Slide from "@material-ui/core/Slide";
import { CustomTooltip } from "../../Header/Header";


const ModalChangeCalendar = props => {
  const {
    show,
    calendar,
    btnSaveAction,
    btnAddAllocationType,
    existAddTypes,
    exitModal,
    activitySale,
    changeActivitySale,
    btnChangeActivity
  } = props


  const buttons = themeButtons();
  return (
    <Slide in={show} direction="left" mountOnEnter unmountOnExit>
      <div className={`modal-calendar ${calendar === "busy" ? "busy" : ''}`}>
        <div className="modal-calendar__wrp">
          <div className="modal-calendar__header">
            Редактирование
            <IconButton onClick={exitModal} style={{ padding: "8px" }}>
              <CloseIcon/>
            </IconButton>
          </div>

          <div className="modal-calendar__body">
            {props.children}
          </div>


          <div className="modal-calendar__footer">
            {calendar === "price" && existAddTypes &&
              <Button className={`btn mb-2 ${buttons.btnGreenOutline}`} onClick={btnAddAllocationType}
                      variant="outlined">
                <FontAwesomeIcon icon={"plus"} className="me-1"/> Добавить тип размещения
              </Button>}

            {activitySale && <>
              {(btnChangeActivity === "close" || btnChangeActivity === "all") && <CustomTooltip
                title={"Закрывает даты для бронирований от туристов, при этом цены в календаре остаются прежними"}
                arrow placement="top">
                <Button className={`btn mb-2 ${buttons.btnWarn}`} onClick={() => changeActivitySale('N')}>
                  Закрыть активность продаж
                </Button>
              </CustomTooltip>}

              {(btnChangeActivity === "open" || btnChangeActivity === "all") && <CustomTooltip
                title={"Открывает даты для бронирований от туристов, если они ранее были закрыты, при этом цены в календаре остаются прежними"}
                arrow placement="top">
                <Button className={`btn mb-2 ${buttons.btnWarnOutline}`}
                        onClick={() => changeActivitySale('Y')}
                        variant="outlined">
                  Открыть активность продаж
                </Button>
              </CustomTooltip>}


            </>}


            <Button onClick={() => btnSaveAction()} className={`btn ${buttons.btnGreen}`}>Сохранить</Button>
          </div>

        </div>
      </div>
    </Slide>
  );

}


export default ModalChangeCalendar;
